/**
 * @typedef {Object.<string, any>} FileContext
 */

/** @type {FileContext} */
const FileContext = {};

export { FileContext };